import "./App.css";
import { Provider } from 'react-redux';
import { store } from "./state/store";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Login from "./pages/Login/Login";
import BookingTabs from "./pages/Bookings/BookingTabs";
import Accounts from "./pages/Accounts/Accounts";
import BecomePartner from "./pages/Client/BecomePartner";
import UpdateBooking from "./pages/Bookings/UpdateBooking";
import PlayroomList from "./pages/Playroom/PlayroomList";
import ContactAdmin from "./pages/Client/ContactAdmin";
import Playroom from "./pages/Playroom/PlayroomPage";
import AuthProvider from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ReservationForm from "./pages/Client/ReservationForm";
import InitialPage from "./pages/Client/InitialPage";
import InitialListOfPlayrooms from "./pages/Client/InitialListOfPlayrooms";
import PlayroomProvider from "./context/PlayroomsContext";
import PlayroomDetails from "./pages/Client/PlayroomDetails";
import BookingDateTimeSelection from "./pages/Client/BookingDateTimeSelection";
import { BookingProvider } from "./context/BookingContext";
import PackageSelection from "./pages/Client/PackageSelection";
import SpecialOffersSelection from "./pages/Client/SpecialOffersSelection";
import ReservationReview from "./pages/Client/ReservationReview";
import ScrollToTop from "./components/ScrollToTop";
import CheckmarkAnimation from "./pages/Client/ChechmarkAnimation";
import { useEffect } from "react";
import Footer from "./components/Footer";
import TermsOfService from "./pages/Client/TermsOfService";

function App() {
  useEffect(() => {
    // Add meta tag for disabling zoom on mobile devices
    const metaTag = document.createElement('meta');
    metaTag.name = "viewport";
    metaTag.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
    document.getElementsByTagName('head')[0].appendChild(metaTag);

    // Cleanup function to remove the meta tag when the component is unmounted
    return () => {
      document.getElementsByTagName('head')[0].removeChild(metaTag);
    };
  }, []);
  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter>
          <BookingProvider>
            <PlayroomProvider>
              <AuthProvider>
                <Navbar />
                <ScrollToTop />
                <Routes>
                  <Route element={<Login />} exact path={"/login"} />
                  <Route element={<TermsOfService />} exact path={"/terms-of-service"} />
                  <Route element={<ContactAdmin />} exact path={"/contact"} />
                  <Route element={<BecomePartner />} exact path={"/become-partner"} />
                  <Route element={<InitialPage />} exact path={"/"} />
                  <Route element={<InitialListOfPlayrooms />} exact path={"/get-playrooms"} />
                  <Route element={<PlayroomDetails />} exact path={"/playroom-details"} />
                  <Route element={<BookingDateTimeSelection />} exact path={"/booking-time"} />
                  <Route element={<ReservationForm />} exact path={"/reservation-form"} />
                  <Route element={<PackageSelection />} exact path={"/package-selection"} />
                  <Route element={<SpecialOffersSelection />} exact path={"/special-offers"} />
                  <Route element={<ReservationReview />} exact path={"/reservation-review"} />
                  <Route element={<CheckmarkAnimation />} exact path={"/finish"} />
                  <Route element={<ProtectedRoute />}>
                    <Route element={<BookingTabs />} exact path={"/reservations"} />
                    <Route element={<UpdateBooking />} exact path={"/update-booking/:bookingId/:playroomId"} />
                    <Route element={<Accounts />} exact path={"/accounts"} />
                    <Route element={<PlayroomList />} exact path={"/playrooms"} />
                    <Route element={<Playroom />} exact path={"/playrooms/:playroomId"} />
                  </Route>
                </Routes>
                <Footer /> 
              </AuthProvider>
            </PlayroomProvider>
          </BookingProvider>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
